<template>
	<div id="users" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar mode="settings"></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" :title="title" subtitle="Password Security Portal"></dash-head>		

				<div v-if="!showEditUser && !showAddUser">
					<table-actions hideSearch="true" hideDelete="true" @edit-click="showHideEditUser(true)" :editEnabled="checkedRows.length === 1">
						<span slot="filter">
							<select id="site-select" class="form-control custom-select" @change="getUsers" v-model="site" v-if="isInRole('GlobalAdmin')">
								<option v-for="option in sites" :value="option.partitionKey" :key="option.partitionKey">{{option.rowKey}}</option>
							</select>
						</span>
					</table-actions>

					<table-view id="users-results">
						<table-row slot="header">
							<table-header></table-header>
							<table-header class="headerSortDown2">Email</table-header>
							<table-header>Roles</table-header>
							<table-header>Show Password</table-header>
						</table-row>
						<table-row slot="body" v-for="result in results" :key="result.rowKey">
							<table-cell><input type="checkbox" class="select-row" :value="result.email" v-model="checkedRows"></table-cell>
							<table-cell>{{result.email}}</table-cell>
							<table-cell>{{result.roles.join(' ')}}</table-cell>
							<table-cell>{{result.showPasswords ? 'Yes' : 'No'}}</table-cell>
						</table-row>
					</table-view>

					<div class="row">
						<div class="col-md-6">
							<table-pagination ref="tablePagination" :page="1" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
						</div>					
						<div class="col-md-6">
							<div class="text-right">
								<button v-if="checkedRows.length==1 && isInRole('GlobalAdmin')" class="btn btn-outline-primary px-3" @click.prevent="switchUser">Switch To User</button>
								<button class="btn btn-outline-primary px-3" @click.prevent="showHideAddUser(true)">Add User</button>
							</div>
						</div>
					</div>
				</div>

				<div v-if="showEditUser">
					<hr class="mt-3 mb-3">
					<edit-user-form :user="selectedUser" @close-edit-user="showHideEditUser(false)"></edit-user-form>
				</div>

				<div v-if="showAddUser">
					<hr class="mt-3 mb-3">
					<add-user-form :site="site" :data="data" @close-add-user="showHideAddUser(false)"></add-user-form>
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'
	import EditUserForm from './EditUserForm'
	import AddUserForm from './AddUserForm'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'UsersPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination, EditUserForm, AddUserForm},
		data() {
			return {
				title: 'Users',
				totalRows: 0,
				results: null,
				loadingData: false,
				data: null,
				error: null,
				resultFound: null,
				checkedRows: [],
				site:store.state.user.site,
				sites:[],
				showEditUser: false,
				showAddUser: false
			}
		},
		computed: {
			selectedUser() {
				if (!this.checkedRows.length) return {};

				const filtered = this.results.filter(result => result.email === this.checkedRows[0]);
				return filtered[0];
			}
		},
		methods: {
			showHideEditUser(value) {
				this.title = (value) ? 'Edit User' : 'Users';
				this.showEditUser = value;
			},
			showHideAddUser(value) {
				this.title = (value) ? 'Add User' : 'Users';
				this.showAddUser = value;

				//Reload
				if (!this.showAddUser) this.getUsers();
			},
			async getUsers() {
				let response = await api.get(`system/users/${this.site}`);

				this.data = response.data;
				this.totalRows = response.data.length;
				this.checkedRows = [];
				this.pageChanged(1);
			},
			async deleteClicked(value) {

			},
			async switchUser() {
					let response = await api.put('token/switchuser', {username:this.checkedRows[0], site:parseInt(this.site)})

					//Ensure the user details are loaded
					store.commit('switch', response.data);
					await store.dispatch('getUserAsync');

					store.dispatch('getDomainsAsync');
					store.dispatch('getEmailsAsync');
					store.dispatch('getAuditsAsync');
					store.dispatch('getSourcesAsync');

					//Redirect to domains as the home page for now
					router.push({name: 'domains'});  
			},
			pageChanged(value) {
				const start = (value-1) * this.pageSize;		
				
				this.results = [];								

				for (var result of this.data.slice(start, start + this.pageSize)) {				
					this.results.push(result);
				}							
			},
			isInRole(role) {
				if (!store.state.user || !store.state.user.roles) return false;
				return store.state.user.roles.indexOf(role) > -1;
			}
		},
		async mounted() {
			this.getUsers();

			//Load Sites
			if (this.isInRole('SiteAdmin')) {
				try
				{
					const response = await api.get(`system/sites`);					

					//Sort data by Site id numeric
					response.data.sort((a,b) => (a.rowKey.toLowerCase() > b.rowKey.toLowerCase()) ? 1 : -1);
					this.sites = response.data;
				}
				catch(err) {			
					this.error = err + ""; //Get the string representation of the error		
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/UsersPanel.vue